"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseViewModel_1 = require("./base/baseViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.defaultFilters = this.options.defaultFilters;
        $(document).off("submit", "#work-search-form");
        $(document).on("submit", "#work-search-form", function (event) {
            var $form = $(event.currentTarget);
            var elemetsToDelete = [];
            $form.serializeArray().forEach(function (element, index, array) {
                var defaultValue = _this.defaultFilters.find(function (x) { return x.Key === element.name; });
                if (element.value === "" || defaultValue && defaultValue.Value === element.value) {
                    elemetsToDelete.push(element.name);
                }
            });
            elemetsToDelete.forEach(function (element, index, array) {
                $form.find("[name=\"" + element + "\"]").remove();
            });
        });
        var autocompleteStandaloneAjax = app.f7.autocomplete({
            openIn: 'popup',
            opener: '#tagsAutocomplete',
            multiple: true,
            valueProperty: 'title',
            textProperty: 'title',
            limit: 20,
            value: $('#tagsAutocomplete').find('input').map(function (id, el) {
                return $(el).val();
            }),
            preloader: true,
            source: function (obj, query, render) {
                var autocomplete = this;
                var results = [];
                if (query.length === 0) {
                    render(results);
                    return;
                }
                ajaxUtils_1.AjaxUtils.get("work/searchTags", { q: query, mobileSearch: true }).done(function (result) {
                    if (result.isSuccessful) {
                        // Render items by passing array with result items
                        render(result.data);
                    }
                    else {
                        alert(result.messages[0]);
                    }
                });
            },
            onChange: function (obj, value) {
                var itemText = [];
                var tagsEl = $('#tagsAutocomplete');
                $('#tagsAutocomplete').find('input').remove();
                for (var i = 0; i < value.length; i++) {
                    itemText.push(value[i].title || value[i]);
                    tagsEl.append("<input type=\"hidden\" value=\"" + (value[i].title || value[i]) + "\" name=\"tags\">");
                }
                var text = itemText.length ? itemText.join(', ') : 'Любые';
                tagsEl.find('.item-after').text(text);
            }
        });
        $(".input-clear").on("click", function () {
            $(this).siblings("input").val("").trigger("change").focus();
        });
    }
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=searchWorks.js.map